<template>
<div>
<PersonalData/>

</div>
</template>
<script>
import PersonalData from "../../components/academic/PersonalData.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   PersonalData
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>